import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import SectionHeading from "@/components/base/SectionHeading";
import MovieCard from "@/components/base/MovieCard";
import HeroCarousel from "./components/HeroCarousel";
import CategorySection from "./components/CategorySection";
import NewsSection from "./components/NewsSection";
import AnalysisSection from "./components/AnalysisSection";
import { movies } from "@/mocks/movies";

const featured = [...movies].sort((a, b) => b.popularity - a.popularity).slice(0, 8);

export default function Home() {
  useSeo({
    title: "蜜桃成熟时1997 - 经典电影介绍与剧情解析",
    description:
      "蜜桃成熟时1997网站提供丰富的电影信息和剧情解析，涵盖该片的详细介绍、演员阵容及观影指南，方便用户全面了解这部经典影片。",
    keywords: "蜜桃成熟时1997,蜜桃成熟时,经典电影,电影介绍,剧情解析,演员阵容,影视资讯",
  });

  return (
    <div className="w-full">
      <HeroCarousel />

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <SectionHeading
          eyebrow="Featured"
          title="热门影片推荐"
          description="九十年代经典亚洲电影精选，点击卡片查看完整资料与剧情解析。"
          linkTo="/category"
          linkLabel="浏览全部影片"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {featured.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </section>

      <CategorySection />
      <NewsSection />
      <AnalysisSection />

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="rounded-lg border border-background-200 bg-background-100 px-6 py-10 md:px-12 md:py-14">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 items-center">
            <div className="lg:col-span-2">
              <p className="text-xs font-medium tracking-widest text-primary-600 uppercase mb-3">
                About Us
              </p>
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
                关于蜜桃成熟时1997影视内容站
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                本站以经典电影《蜜桃成熟时1997》为核心，围绕九十年代经典亚洲电影，提供详尽的影片介绍、剧情解析、演员资料与观影指南。我们希望用专业的资料与温暖的表达，让每一位影迷都能在这里沉浸式地阅读与研究。
              </p>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                站内内容均为示范演示数据，不提供任何播放、下载与付费功能。
              </p>
              <div className="mt-6 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/about"
                  className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  了解我们
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/category"
                  className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap"
                >
                  开始探索影片
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="rounded-lg bg-background-50 border border-background-200 p-5 text-center">
                <p className="font-heading text-3xl font-bold text-primary-600">15</p>
                <p className="mt-1 text-xs text-foreground-500">收录影片</p>
              </div>
              <div className="rounded-lg bg-background-50 border border-background-200 p-5 text-center">
                <p className="font-heading text-3xl font-bold text-accent-600">18</p>
                <p className="mt-1 text-xs text-foreground-500">演员资料</p>
              </div>
              <div className="rounded-lg bg-background-50 border border-background-200 p-5 text-center">
                <p className="font-heading text-3xl font-bold text-primary-600">6</p>
                <p className="mt-1 text-xs text-foreground-500">深度解析</p>
              </div>
              <div className="rounded-lg bg-background-50 border border-background-200 p-5 text-center">
                <p className="font-heading text-3xl font-bold text-accent-600">6</p>
                <p className="mt-1 text-xs text-foreground-500">观影指南</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}